
import util,{_} from '@/libs/util'
import Group from 'vux/src/components/group/index.vue'

import common from '@/libs/common.mixin'
import globals from '@/libs/globals.mixin'

export default{
mixins: [ common, globals ],
components: {
Group
},
data () {
return {
data: {},
id: this.$route.params.id
}
},
mounted () {
this.getGlobals().then(()=>{
this.init_data()
})
},
computed: {
logo () {
let ui = window.CLIENT_PARAMS,
result = '/static/img/logo-2.jpg'
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.logo!=''){
result = ui.mobile.logo
}
return result
},
sysName () {
let result = '校360学习管家',
ui = window.CLIENT_PARAMS
if(!_.isEmpty(ui)&&!_.isEmpty(ui.mobile)&&ui.mobile.system_name!=''){
result = ui.mobile.system_name
}
return result
},
avatar () {
if(this.data.sid>0){
return this.data.student.photo_url
}else{
return ''
}
},
name () {
if(this.data.sid>0){
return this.data.student.student_name
}else{
return this.data.customer.name
}
}
},
methods: {
init_data () {
let uri = util.sprintf('open/study_situation?short_id=%s',this.id)
this.$rest(uri).get()
.success(data=>{
this.data = data
}).error(resposne=>{
this.toast(response.body.message||'获取学情失败~','warn')
})

},
getItemIcon (item,isMulti) {
let map_icon = {true:'icon-android-radio-button-on',false:'icon-android-radio-button-off'}

if(isMulti){
map_icon = {true:'icon-android-checkbox',false:'icon-android-checkbox-outline-blank'}
}

return map_icon[item.select$]
},
getGlobals () {
return new Promise((resolve,reject)=>{
this.$rest('open/global/all').get()
.success(data=>{
this.$store.commit('setGlobalVars',data)
resolve()
}).error(response=>{
this.toast(response.body.message||'获取失败~','warn')
reject(response)
})
})

}
}
}



// WEBPACK FOOTER //
// ./src/views/public/situation.vue